import managerHeaderMonthUrl from './managerHeaderMonth.html';
import employeeHeaderMonthUrl from './employeeHeaderMonth.html';

class CalendarHeaderMonthCtrl {
  constructor(ShiftHeaderUtils, dateFilter) {
    'ngInject';

    Object.assign(this, { ShiftHeaderUtils, dateFilter });
  }

  $onInit() {
    this.templateUrl = this.forManager ? managerHeaderMonthUrl : employeeHeaderMonthUrl;
  }

  matchesTodaysDay(day) {
    const today = this.ShiftHeaderUtils.getCurrentDate();
    return this.dateFilter(today) === this.dateFilter(day);
  }
}

export default {
  template: '<ng-include src="ctrl.templateUrl" />',
  controller: CalendarHeaderMonthCtrl,
  controllerAs: 'ctrl',
  bindings: {
    currentDays: '<',
    forManager: '<',
  },
};
